import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgPipesModule, OrderByPipe, FilterByPipe } from 'ngx-pipes';

import { ButtonModule } from '../button/index';
import { DropdownModule } from '../dropdown/index';
import { FormModule } from '../form/index';
import { GenericModule } from '../generic/index';
import { IconModule } from '../icon/index';
import { LoadingModule } from '../loading/index';
import { TryAgainModule } from '../try-again/index';

import { TableService } from './table.service';

import { TableComponent } from './table.component';
import { TableButtonComponent } from './components/button/button.component';
import { TableContentComponent } from './components/content/content.component';
import { TableFooterComponent } from './components/footer/footer.component';
import { TableHeaderComponent } from './components/header/header.component';

export { TableService } from './table.service';

export * from './table.interface';

export { Table } from './classes/table';
export { TableButton } from './classes/button';
export { TableColumn } from './classes/column';
export { TableGroup } from './classes/group';
export { TableItem } from './classes/item';
export { TableRemote } from './classes/remote';
export { TableRow } from './classes/row';

export { TableComponent } from './table.component';
export { TableButtonComponent } from './components/button/button.component';
export { TableContentComponent } from './components/content/content.component';
export { TableFooterComponent } from './components/footer/footer.component';
export { TableHeaderComponent } from './components/header/header.component';

const TableComponents = [
  TableComponent,
  TableButtonComponent,
  TableContentComponent,
  TableFooterComponent,
  TableHeaderComponent
];

@NgModule({
  imports: [
    CommonModule,
    NgPipesModule,

    ButtonModule,
    DropdownModule,
    FormModule,
    GenericModule,
    IconModule,
    LoadingModule,
    TryAgainModule
  ],
  exports: [
    TableComponent
  ],
  declarations: TableComponents,
  providers: [
    TableService,
    OrderByPipe,
    FilterByPipe
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ]
})
export class TableModule { }
